<template>
  <div class="gray-box d-block">
    <div class="accordion-block-box d-flex gap-3 align-items-center">
      <img :src="animalImage" style="object-fit: unset !important;" />
      <div class="accordion-block-info w-100">
        <div class="accordion-block-info-top d-flex align-items-center gap-3">
          <span class="border-title">{{
            $t("calcul_accordion.animal_title", { name: animalName, type: animalType })
          }}</span>
          <p>
            <i class="ti ti-calendar pe-2 blue-color"></i
            ><small>{{ $t("calcul_accordion.date_label", { date: formattedVisitDate }) }}</small>
          </p>
        </div>
        <div class="accordion-block-info-bottom mt-3">
          <ul class="d-flex align-items-center gap-2">
            <li>
              <span>{{ $t("calcul_accordion.bag_name") }}</span>
              <strong>{{ productReference }}</strong>
            </li>

            <li>
              <span>{{ $t("calcul_accordion.ration_per_day") }}</span>
              <strong>{{ dailyRation }}</strong>
            </li>

            <li>
              <span>{{ $t("calcul_accordion.bag_duration") }}</span>
              <strong>{{ bagDuration }}</strong>
            </li>

            <li>
              <span>{{ $t("calcul_accordion.cost_per_day") }}</span>
              <strong>{{ dailyCost }}</strong>
            </li>
          </ul>
          <div class="accordion-block-right d-flex align-items-center gap-3">
            <a href="#" class="btn btn-outline-orange" @click.prevent="handleReminder"
              ><i class="ti ti-bell"></i> <span>{{ $t("calcul_accordion.reminder") }}</span></a
            >
            <a href="#" class="btn btn-outline-orange" @click.prevent="handleDownloadPdf"
              ><i class="ti ti-download"></i> <span>{{ $t("calcul_accordion.download_pdf") }}</span></a
            >
            <!--            <a href="#" class="btn btn-orange btn-circle" @click.prevent="handleEdit">-->
            <!--              <img :src="editIcon" />-->
            <!--            </a>-->
            <a href="#" class="btn btn-orange btn-circle" @click.prevent="handleDelete">
              <img :src="deleteIcon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import animal from "@/assets/images/animal.png";
  import chien1 from "@/assets/images/chien1.jpg";
  import chat1 from "@/assets/images/chat1.png";
  import editIcon from "@/assets/icons/edit.svg";
  import deleteIcon from "@/assets/icons/delete.svg";

  export default {
    name: "CalculAccordion",
    props: {
      ration: {
        type: Object,
        required: true,
        default: () => ({}),
      },
    },
    data() {
      return {
        animal,
        chien1,
        chat1,
        editIcon,
        deleteIcon,
      };
    },
    computed: {
      animalName() {
        return this.ration?.animal?.name || "Animal";
      },
      animalType() {
        return this.ration?.animal?.animalTypeName || "Type";
      },
      formattedVisitDate() {
        if (!this.ration?.visite) return "Date non définie";

        try {
          const date = new Date(this.ration.visite);
          return date.toLocaleDateString("fr-FR", {
            day: "numeric",
            month: "long",
            year: "numeric",
          });
        } catch (error) {
          return "Date invalide";
        }
      },
      productReference() {
        const product = this.ration?.product;
        const variant = this.ration?.productVariant;

        if (product && variant) {
          const productName = product.name || "Produit";
          const variantWeight = variant.weight || "";

          if (variantWeight) {
            return `${productName} - ${variantWeight}kg`;
          }
          return productName;
        }

        return "Référence non définie";
      },
      dailyRation() {
        const amount = this.ration?.recommendedDailyAmount;
        if (!amount) return "-";

        return `${Math.round(parseFloat(amount))} g`;
      },
      bagDuration() {
        const duration = this.ration?.consumptionDurationDays;
        if (!duration || duration === 0) {
          // Calculer la durée si elle n'est pas fournie
          const dailyAmount = parseFloat(this.ration?.recommendedDailyAmount || 0);
          const productWeight = parseFloat(this.ration?.productWeight || 0);

          if (dailyAmount > 0 && productWeight > 0) {
            const calculatedDuration = Math.round((productWeight * 1000) / dailyAmount);
            return `${calculatedDuration} jours`;
          }

          return "-";
        }

        return `${duration} jours`;
      },
      dailyCost() {
        if (!this.ration?.showDailyExpenses || !this.ration?.dailyExpenses) {
          return "-";
        }

        // 🔧 FIX: dailyExpenses est déjà en euros, pas en centimes
        const costEuros = parseFloat(this.ration.dailyExpenses);
        if (!isNaN(costEuros)) {
          return `${costEuros.toFixed(2)} €`;
        }
        return "-";
      },
      animalImage() {
        const animalTypeId = this.ration?.animal?.animalTypeId;
        if (animalTypeId === 1) {
          return this.chien1;
        } else if (animalTypeId === 2) {
          return this.chat1;
        }
        return this.chien1; // Par défaut pour les autres types d'animaux
      },
    },
    methods: {
      handleReminder() {
        this.$emit("reminder", this.ration);
      },
      handleDownloadPdf() {
        this.$emit("download-pdf", this.ration);
      },
      handleEdit() {
        this.$emit("edit", this.ration);
      },
      handleDelete() {
        this.$emit("delete", this.ration);
      },
    },
  };
</script>

<style >
  @import "@/assets/css/components/CalculRation.css";
</style>
